import { z } from "zod"

export const pvWattsV8OutputsSchema = z.object({
  /**
   * Monthly AC system output. (kWhac)
   * The array of values represents the value for each month,
   * with the first element being for January and the last
   * element being for December.
   *
   * Type: array of decimal
   */
  ac_monthly: z.array(z.number()),

  /**
   * Annual AC system output. (kWhac)
   * Type: decimal
   */
  ac_annual: z.number(),

  /**
   * Hourly AC system output (only when timeframe=hourly). (Wac)
   *
   * Type: array of decimal
   */
  ac: z.array(z.number()),
})

export type PvWattsV8Outputs = z.infer<typeof pvWattsV8OutputsSchema>
